import * as React from "react"

const Footer = () =>
    <div className="space-y-1 bg-blue-900 max-w-screen-lg m-auto p-5">
        <p className="text-blue-100 text-xs md:text-sm tracking-widest">Rephorm PTY LTD 2013-2022  |  ABN 14 164 088 019</p>
    </div>
export default Footer;